<template>
	<div class="login-page-container" a_id="login-page-container" extension-name="login-page">
		<div class="login-page-header" a_id="login-page-header">
			<span v-if="isTargetAgent">
				{{'LoginPage.AgentLogin' | translate}}
			</span>
			<span v-else>
				{{'LoginPage.LoginHeaderStart' | translate}} <b>{{'LoginPage.LoginHeaderEnd' | translate}}</b>
			</span>

		</div>
		<form @submit.prevent.stop>
			<login-page-field
				input-id="account"
				a_id="login-page-field-accountId"
				v-model="accountId"
				:title="'LoginPage.AccountId' | translate"
				:placeholder="'LoginPage.AccountId' | translate"
				:disabled="accountInputDisabled"
				@enter="loginClicked"
				:show-error-message="loginFailed"
			/>

			<login-page-field
				input-id="username"
				a_id="login-page-field-userName"
				v-model="userName"
				:title="'LoginPage.UserName' | translate"
				:placeholder="'LoginPage.UserName' | translate"
				:image-type="'userName'"
				:show-error-message="loginFailed"
				@enter="loginClicked"/>

			<login-page-field
				input-id="password"
				a_id="login-page-field-password"
				v-model="password"
				:title="'LoginPage.Password' | translate"
				:type="'password'"
				:show-error-message="loginFailed"
				:error-message="errorMessage || ('LoginPage.InvalidPasswordErrorMessage' | translate)"
				:placeholder="'LoginPage.Password' | translate"
				:image-type="'password'"
				@enter="loginClicked"/>

			<div class="login-page-footer" a_id="login-page-footer">
				<button v-if="accountId && userName && password"
						class="login-page-footer-button-right"
						@click.prevent.stop="loginClicked"
						a_id="login-page-footer-login-button">
					{{'LoginPage.LoginButton' | translate}}
				</button>
				<button v-else disabled
						class="login-page-footer-button-right"
						a_id="login-page-footer-login-button-disabled">
					{{'LoginPage.LoginButton' | translate}}
				</button>
				<a class="login-page-footer-link"
				   href="#"
				   @click="forgotPasswordClicked"
				   a_id="login-page-footer-forgot-link">
					{{'LoginPage.ForgotPasswordLink' | translate}}
				</a>
			</div>
		</form>
	</div>
</template>

<script>
	import BasePage from './BasePage.vue';
	import LoginPageField from './LoginPageField.vue';
	import LoginService from '../services/LoginService';
	import UrlService from '../../../common/services/src/url/urlService';

	export default BasePage.extend( {
		name: "LoginSignInPage",
		props:{
			"currentAccountId" : {
				type: String,
				required: false
			}
		},
		methods: {
			forgotPasswordClicked(){
				if(!this.accountId){
					this.$emit('notify',
						this.translateService.getString('LoginPage.ForgetClickedWithoutAccountIdTitle'),
						this.translateService.getString('LoginPage.ForgetClickedWithoutAccountIdMessage'));
				} else {
					this.$emit("navigate", "ForgotPasswordPage");
				}
			},
			showError(data){
				this.loginFailed = true;

				if(data && data.message) {
					this.errorMessage = this.extractErrorMessage(data.message);
				}
				else {
					this.errorMessage = this.translateService.getString("LoginPage.GeneralError");
				}
			},
			loginClicked(){
				if( !this.accountId || !this.userName || !this.password){
					return;
				}

				LoginService.auth(this.accountId, this.userName, this.password, 'loginapplicationkey').then(
					(res) => {
						if (!LoginService.isAuthorized(res.data.roles)) {
							this.loginFailed = true;							
							this.errorMessage = this.translateService.getString('LoginPage.AgentAppLoginError');
							return;
						}
						this.loginFailed = false;
						LoginService.keepLoginInfo(this.userName, this.accountId);
						if(!res.data.mfa){
							this.$emit("navigate", "LoginMFAPage");
							return;
						}

						// set the Cookies && Local/Session storage(will be used by all the Apps)
						LoginService.updateLoginData(res.data["Access-Token"], res.data.userId, res.data["roles"]);

						//  redirect to previous APP
						LoginService.redirectToApp();
					},
					(err) => {
						this.showError(err.data);
					}
				);
			},
		},
		data(){
			return {
				accountId: '',
				userName: '',
				password: '',
				loginFailed: false,
				accountInputDisabled: false,
				errorMessage: '',
				isTargetAgent: LoginService.isTargetAgentApp()
			};
		},
		watch: {
			accountId(){
				this.$emit('accountChanged', this.accountId)
			}
		},
		components: {
			LoginPageField
		},
		model: {
			// Parent can use "v-model" (by default, the expected event's name is "input")
			event: "navigate"
		},
		mounted(){
			let accountId = UrlService.getSearchParam('accountId');
			if(accountId) {
				this.accountId = accountId;
				this.accountInputDisabled = true;
			}

		},
		dependencies: [{
			translateService : 'com.jacada.common.services.TranslateService'
		}]
	});

</script>

<style lang="scss">
	@import '../sass/loginPage.scss';

</style>


// WEBPACK FOOTER //
// src/app/LoginSignInPage.vue